export class A11yService {

  public static setElementAsDecorative(el: Element) {
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
  }

  public static observeDomChanges() {
    const targetsCssSelector = 'iframe[id*="sovrn"]';

    // First pass (on page load)
    [...document.querySelectorAll(`${targetsCssSelector}:not([aria-hidden="true"])`)].forEach((el) => this.setElementAsDecorative(el));

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        ([...mutation.addedNodes] as Element[]).forEach((el) => {
          // Second pass (after page load)
          if (el.nodeType === Node.ELEMENT_NODE && el.matches(`${targetsCssSelector}:not([aria-hidden="true"])`)) {
            this.setElementAsDecorative(el);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }
}